var map = {
	"./arrow-swap.vue": [
		29161,
		9161
	],
	"./arrow-up-down.vue": [
		12273,
		2273
	],
	"./arrow.vue": [
		33976,
		3976
	],
	"./arrows-line.vue": [
		6142,
		6142
	],
	"./bar-chart-steps.vue": [
		82497,
		2497
	],
	"./bin.vue": [
		47241,
		7241
	],
	"./bolt.vue": [
		6774,
		6774
	],
	"./bounding-box-circles.vue": [
		47915,
		7915
	],
	"./box.vue": [
		73860,
		3860
	],
	"./calendar.vue": [
		61157,
		1157
	],
	"./caret-down-slim.vue": [
		47910,
		7910
	],
	"./caret-down-thick.vue": [
		99934,
		9934
	],
	"./caret-down.vue": [
		40223,
		2981
	],
	"./caret-thin.vue": [
		29282,
		9282
	],
	"./category-alt.vue": [
		41820,
		1820
	],
	"./check-circle.vue": [
		60492,
		492
	],
	"./check.vue": [
		93908,
		3908
	],
	"./checkbox-list.vue": [
		66910,
		6910
	],
	"./chevron-down.vue": [
		78167,
		8167
	],
	"./chevron.vue": [
		50199,
		199
	],
	"./circle-check-border.vue": [
		30996,
		996
	],
	"./circle-check.vue": [
		11174,
		1174
	],
	"./circle-close-border.vue": [
		20589,
		589
	],
	"./circle-close.vue": [
		69489,
		9489
	],
	"./circle-filter.vue": [
		79638,
		9638
	],
	"./circle-info.vue": [
		40536,
		536
	],
	"./circle.vue": [
		18190,
		8190
	],
	"./close-bold.vue": [
		21988,
		1988
	],
	"./close.vue": [
		99823,
		9823
	],
	"./cogwheel.vue": [
		13827,
		3827
	],
	"./copy-filled.vue": [
		81345,
		1345
	],
	"./copy-plain.vue": [
		33338,
		3338
	],
	"./copy.vue": [
		65400,
		5400
	],
	"./dashboard.vue": [
		95555,
		5555
	],
	"./discord-circle.vue": [
		42506,
		2506
	],
	"./discord.vue": [
		27003,
		7003
	],
	"./dollar-coin.vue": [
		6952,
		6952
	],
	"./download.vue": [
		79781,
		9781
	],
	"./empty.vue": [
		25551,
		5551
	],
	"./exchange.vue": [
		8747,
		8747
	],
	"./exclamation-circle-fill.vue": [
		3520,
		3520
	],
	"./exit.vue": [
		16440,
		6440
	],
	"./external-link-arrow.vue": [
		68686,
		9428
	],
	"./external-link.vue": [
		69504,
		9504
	],
	"./facebook.vue": [
		77177,
		7177
	],
	"./file-filled.vue": [
		15944,
		5944
	],
	"./file.vue": [
		1432,
		1432
	],
	"./filter.vue": [
		32907,
		2907
	],
	"./gas.vue": [
		35758,
		5758
	],
	"./gear.vue": [
		89667,
		9667
	],
	"./gift.vue": [
		58455,
		8455
	],
	"./globe.vue": [
		13638,
		3638
	],
	"./google.vue": [
		76036,
		6036
	],
	"./governance.vue": [
		10777,
		777
	],
	"./graph-up.vue": [
		59267,
		9267
	],
	"./grid.vue": [
		97309,
		7309
	],
	"./hide.vue": [
		75046,
		5046
	],
	"./history.vue": [
		92411,
		2411
	],
	"./icon-ethereum.vue": [
		56229,
		6229
	],
	"./icon-injective.vue": [
		75745,
		5745
	],
	"./info.vue": [
		72254,
		2254
	],
	"./lightning-fill.vue": [
		6856,
		6856
	],
	"./link.vue": [
		42913,
		2913
	],
	"./lock.vue": [
		11906,
		1906
	],
	"./menu-alt.vue": [
		26131,
		6131
	],
	"./menu.vue": [
		25577,
		5577
	],
	"./minus.vue": [
		38808,
		8808
	],
	"./monitor.vue": [
		63719,
		7363
	],
	"./moon.vue": [
		41033,
		1033
	],
	"./nav-arrow.vue": [
		84153,
		4153
	],
	"./network.vue": [
		85874,
		5874
	],
	"./news.vue": [
		74376,
		4376
	],
	"./not-found.vue": [
		91691,
		5510
	],
	"./pen-to-square.vue": [
		66195,
		6195
	],
	"./pencil.vue": [
		3795,
		3795
	],
	"./plus.vue": [
		86441,
		6441
	],
	"./profile.vue": [
		45974,
		5974
	],
	"./rectangle-chart.vue": [
		39530,
		9530
	],
	"./rectangle-list.vue": [
		94213,
		4213
	],
	"./reddit-circle.vue": [
		80530,
		530
	],
	"./reddit.vue": [
		28894,
		8894
	],
	"./refresh.vue": [
		28041,
		8041
	],
	"./rotate.vue": [
		3997,
		3997
	],
	"./search.vue": [
		8113,
		8113
	],
	"./share.vue": [
		36267,
		6267
	],
	"./shield-lock-fill.vue": [
		36767,
		6767
	],
	"./show.vue": [
		15794,
		5794
	],
	"./sliders.vue": [
		57129,
		9326
	],
	"./social/discord.vue": [
		70060,
		60
	],
	"./social/facebook.vue": [
		15627,
		5627
	],
	"./social/google.vue": [
		13420,
		3420
	],
	"./social/twitter.vue": [
		47770,
		7770
	],
	"./square-featured.vue": [
		16987,
		6987
	],
	"./square.vue": [
		45537,
		5537
	],
	"./staking.vue": [
		98251,
		8251
	],
	"./star-border.vue": [
		30596,
		596
	],
	"./star.vue": [
		26400,
		6400
	],
	"./stop.vue": [
		88733,
		8733
	],
	"./sun.vue": [
		3206,
		3206
	],
	"./swap-bolt.vue": [
		98815,
		8815
	],
	"./swap.vue": [
		39738,
		9738
	],
	"./telegram-circle.vue": [
		94600,
		4600
	],
	"./telegram.vue": [
		86890,
		3001
	],
	"./triangle-down.vue": [
		40769,
		769
	],
	"./triangle.vue": [
		76737,
		6737
	],
	"./trophy.vue": [
		89397,
		9397
	],
	"./twitter-circle.vue": [
		43004,
		3004
	],
	"./twitter.vue": [
		91454,
		1454
	],
	"./user.vue": [
		80638,
		638
	],
	"./vault.vue": [
		9919,
		9919
	],
	"./wallet-filled.vue": [
		35737,
		5737
	],
	"./wallet.vue": [
		90642,
		642
	],
	"./wallet/cosmostation.vue": [
		36503,
		6503
	],
	"./wallet/ethereum.vue": [
		49674,
		9674
	],
	"./wallet/injective.vue": [
		41136,
		1136
	],
	"./wallet/keplr.vue": [
		34412,
		6847
	],
	"./wallet/leap.vue": [
		45840,
		5840
	],
	"./wallet/ledger.vue": [
		35110,
		8129
	],
	"./wallet/metamask.vue": [
		99640,
		9640
	],
	"./wallet/torus.vue": [
		16649,
		6649
	],
	"./wallet/trezor.vue": [
		51939,
		1939
	],
	"./wallet/wallet-connect.vue": [
		52263,
		2263
	],
	"./warn.vue": [
		77263,
		7263
	],
	"./youtube-circle.vue": [
		25829,
		5829
	],
	"./youtube.vue": [
		2562,
		2562
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5720;
module.exports = webpackAsyncContext;